import { THEME_KEYS, ThemeKey } from '@common/constants/themes';

interface TemplateColor {
  name: ThemeKey;
  description: string;
  colors: string[];
}

export const templateColors: TemplateColor[] = [
  {
    name: THEME_KEYS.RECOMMENDED,
    description: 'Crisp & professional',
    colors: ['rgb(131, 188, 201)', 'rgb(251, 248, 242)', 'rgb(178, 163, 133)', 'rgb(66, 60, 57)'],
  },
  {
    name: THEME_KEYS.CREAMY,
    description: 'Warm & inviting',
    colors: ['rgb(110, 25, 25)', 'rgb(228, 197, 138)', 'rgb(240, 132, 117)', 'rgb(225, 217, 199)'],
  },
  {
    name: THEME_KEYS.CONTEMPORARY,
    description: 'Bold & modern',
    colors: ['rgb(255, 248, 241)', 'rgb(224, 190, 154)', 'rgb(91, 77, 67)', 'rgb(162, 103, 45)'],
  },
  {
    name: THEME_KEYS.MATURE,
    description: 'Serene & thoughtful',
    colors: ['rgb(99, 55, 97)', 'rgb(254, 230, 196)', 'rgb(48, 87, 78)', 'rgb(145, 171, 165)'],
  },
  {
    name: THEME_KEYS.NOSTALGIC,
    description: 'Confident & memorable',
    colors: ['rgb(194, 39, 75)', 'rgb(255, 240, 236)', 'rgb(180, 200, 220)', 'rgb(85, 107, 141)'],
  },
  {
    name: THEME_KEYS.TECHNICAL,
    description: 'Energetic & creative',
    colors: ['rgb(32, 97, 183)', 'rgb(189, 233, 251)', 'rgb(234, 224, 218)', 'rgb(208, 224, 205)'],
  },
];
